import type { PopupPositionsType } from "@skbkontur/react-ui";

export const rowMenuTourStep = {
    id: "candyform_rowmenu",
    header: "Действия со строкой",
    content: "Копирование и удаление строк находится в меню рядом с номером строки",
    positions: ["right middle", "right top", "right bottom"] as PopupPositionsType[],
    offset: 20,
};
